import { useCallback, useMemo } from "react";

import { getNextQueryParams } from "components/helpers";
import { ModalTable } from "components/BaseTableV3/ModalTable";
import { useModalContactTable } from "hooks/useModalContactTable";
import ContactService from "services/Contact";

export function ModalContactTable({
  entityId,
  campaignId,
  onInclude,
  onSuccess,
  includeAll,
  contactIds,
  enableSearch = false,
  extraButtons,
  headerIcon,
  header,
}) {
  const queryKey = useMemo(() => `entity_${entityId}_contacts`, [entityId]);
  const { columns } = useModalContactTable({
    entityId,
    campaignId,
    queryKey,
    onInclude,
    onSuccess,
    includeAll,
    contactIds,
  });

  const fetchContacts = useCallback(
    async queryParams => {
      const nextQueryParams = getNextQueryParams(queryParams, columns);

      return ContactService.getContacts({
        ...nextQueryParams,
        entity_id: entityId,
      });
    },
    [columns, entityId]
  );

  return (
    <ModalTable
      columns={columns}
      fetchData={fetchContacts}
      queryKey={queryKey}
      enableSearch={enableSearch}
      extraButtons={extraButtons}
      headerIcon={headerIcon}
      header={header}
    />
  );
}
